import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

// baseQueryWithReauth already handles the retry-after-refresh pattern internally.
// A second retry wrapper would amplify 401 failures (1 initial + N retries) and cause
// the logout loop seen when the refresh response field names didn't match.
export const api = createApi({
    reducerPath: 'api',
    baseQuery: baseQueryWithReauth,
    // Refetch whenever the tab regains focus or the network comes back —
    // requires setupListeners(store.dispatch) in app/store.ts, which was
    // previously missing (making these two flags dead weight app-wide).
    // Matters most for state that changes from OUTSIDE the current tab's
    // own actions, like clock-in/out status: leaving the tab open across a
    // gap (a long shift, a laptop sleep/wake) used to leave every query
    // showing whatever was cached at last fetch, with nothing to prompt a
    // refresh until something happened to invalidate its tag.
    refetchOnFocus: true,
    refetchOnReconnect: true,
    tagTypes: ['User', 'Department', 'Employee', 'Leave', 'Payroll', 'Org', 'Document', 'Notification', 'Request', 'Salary', 'ExpensePolicy', 'PettyCash', 'CashAdvance', 'ExpenseAnalytics', 'LoanType', 'Loan', 'Jobs', 'Candidates', 'Candidate', 'IncrementCycle', 'IncrementPolicy', 'IncrementRequest', 'Roles', 'Permissions', 'Settings', 'Reports', 'Training', 'Performance', 'Attendance', 'Security', 'Branch', 'Asset', 'AssetHandover', 'Benefit', 'DailyReport', 'Alerts', 'Activity', 'LeaveHandover', 'Shifts', 'Biometric'],
    endpoints: (builder) => ({
        getHealth: builder.query<{ status: string }, void>({
            query: () => ({ url: '/health', method: 'GET' }),
        }),
    }),
});
